module.exports = __webpack_public_path__ + "img/ic_24_add.b86d4f9f.svg";